<template>
  <div class="wrapper">
    <loading :show="show" :label="label" :eventBus="bus"></loading>
    <sidebar></sidebar>
    <div class="content">
      <bread-crumb></bread-crumb>
      <router-view> </router-view>
      <eis-footer></eis-footer>
      </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import BreadcrumbBar from './BreadcrumbBar';
import BreadCrumb from './BreadCrumb';
import Sidebar from './Sidebar';
import store from '../store.js';
import config from '../config';
import Loading from 'vue-full-loading';
import { bus } from '../main.js';
import EisFooter from './EisFooter';


function routePermitted(to, next) {

    let permitted = to.matched.filter(
    record => to.name == record.name && store.getters.hasPerm(
            record.meta.requiresPerm
        )
    );

    if(permitted.length == 0){
        next({ path: "/forbidden" });
    }else{
        next();
    }
}

export default {
    data () {
        return {
          CDSFURL: config.CDSFURL,
          bus: bus,
          show: true,
          label: "Loading..."
        }
    },
    components: {
        Sidebar,
        BreadcrumbBar,
        BreadCrumb,
        Loading, 
        EisFooter
    },
    async beforeRouteEnter (to, from, next) {
        let loggedIn = await store.dispatch('initUser');
        if (loggedIn) {
           routePermitted(to, next);
        }else{
            next({
                path: "/login",
                query: { redirect: to.fullPath }
            });
        }
    },
    async beforeRouteUpdate (to, from, next) {
        routePermitted(to, next);
    }
};
</script>
<style type="text/css">

@media only screen and (max-width: 1190px) {
  /* For mobile phones: */
  .content { width: 100%; height: 100%; padding: 0;  }
}

@media only screen and (min-width: 468px) and (max-width: 780px) {
  /* For mobile phones: */
  .content { 
    width: 100%; 
    height: 100%; 
    padding: 0; 
    overflow-y: auto; 
    overflow-x: hidden;
  }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  .content { 
    width: 100%; 
    height: 100%; 
    padding: 0; 
    overflow-y: auto; 
    overflow-x: hidden; 
  }
}

.copyright {
  margin-top: 1%;
  margin-left: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue